import { Navigate } from "react-router-dom";
import Layout from "../components/Layout/Layout";

export default function ProtectedLayout({ children }) {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return <Layout>{children}</Layout>;
}
